import React from "react";
import { PrefillInput } from "@components/input";

const IncomeField = () => {
  return (
    <PrefillInput
      title="Total Income (Including Benefits)"
      type="number"
      inputMode="numeric"
      placeholder="Income"
      prefix={<span>$</span>}
      maxLength={5}
      toolTipText="The TOTAL amount you REGULARLY receive from all sources of income, after tax, shown on your bank statements."
      customClass="incomeField"
      name="totalIncome"
    />
  );
};

export default IncomeField
